<style lang="scss"></style>

<template>
  <div class="add-app-modal">
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(addBan)">

        <section class="mb-2">
          <div v-if="!user">
            <label>Search for a user</label>
            <validation-provider
              #default="{ errors }"
              name="User"
              :rules="{ required: true }"
            >
              <section class="d-flex mb-1">
                <b-form-input v-model="filters.firstname" cy="ban-input-firstname" placeholder="enter firstname" @keyup="startNewSearch()" />
                <b-form-input v-model="filters.lastname" cy="ban-input-lastname" class="mx-1" placeholder="enter last name" @keyup="startNewSearch()" />
                <b-form-input v-model="filters.email" placeholder="enter email" @keyupr="startNewSearch()" />
              </section>

              <b-spinner v-if="loading" variant="primary" label="Loading visitor" />

              <label :class="users.length > 0 ? 'text-success' : 'text-danger'">{{ users.length > 0 ? 'Select a user' : 'Search for users above' }}</label>

              <b-form-select v-model="contact" cy="ban-input-select-user" :class="{ disabled: loading || !users.length }"
                             :state="errors.length > 0 ? false:null" :options="users"
              >
                <b-form-select-option :value="null">Select a user</b-form-select-option>
              </b-form-select>

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </div>

          <div class="mt-2">
            <label>Reason</label>
            <small class="d-block" style="margin-bottom: 5px">Please note this will be shown to the sender.</small>
            <validation-provider
              v-slot="validationContext"
              name="Reason"
              :rules="{ required: true, min: 5 }"
            >
              <b-form-textarea
                v-model="ban.reason"
                rows="3" cy="ban-input-reason"
                max-rows="6"
                :state="getValidationState(validationContext)" class="mb-1" placeholder="Enter reason"
              />

              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </validation-provider>
          </div>

          <div>
            <label class="d-flex justify-content-between">End Date <span>Bans start from today ({{ formatDateToDDMMYYYY() }})</span></label>
            <validation-provider
              v-slot="validationContext"
              name="End-date"
              rules="required|future_date"
            >
              <b-form-datepicker v-model="ban.end_date" class="mb-1" locale="en-uk"
                                 placeholder="Enter end date"
                                 :state="getValidationState(validationContext)"
                                 cy="ban-input-date"
                                 today-button
                                 reset-button
                                 close-button
                                 :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                 :min="minDate"
              />

              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </validation-provider>
          </div>
        </section>

        <section class="d-inline-flex full-width mt-2">
          <div class="ui-spacer" />
          <b-button class="mr-2" @click="$emit('close', true)">Cancel</b-button>
          <b-button cy="ban-input-submit" type="submit" variant="primary">Add Ban</b-button>
        </section>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import moment from 'moment';
// eslint-disable-next-line no-unused-vars
import VisitorUsersService from '@/services/VisitorUsersService';
import BanService from '../../../services/BanService';

export default {
  components: {},
  props: {
    // eslint-disable-next-line vue/require-default-prop
    user: {
      required: false,
      type: Object,
    },
  },
  data() {
    return {
      ban: {
        user_id: '',
        reason: '',
        start_date: '',
        end_date: '',
      },
      users: [],
      contact: null,
      loading: false,
      filters: {
        firstname: '',
        lastname: '',
        email: '',
      },
      timeout: null,
    };
  },
  computed: {
    minDate() {
      return this.getDateToday();
    },
  },
  mounted() {
    if (this.user) {
      this.contact = { ...this.user };
    }
  },
  methods: {
    addBan() {
      this.ban.user_id = this.contact.user_id;
      this.ban.start_date = this.getDateToday();

      this.ban.end_date = new Date(
        new Date(this.ban.end_date).setUTCHours(23, 59, 59, 999),
      ).toISOString();

      BanService.createBan(this.ban).then(() => {
        this.$toast.success(`Added ban for ${this.contact.firstname} ${this.contact.lastname} Successfully`, {
          toastClassName: ['toast-std', 'success-toast'],
        });

        this.$emit('close', true);
        this.$emit('refresh', true);
      }).catch(err => {
        console.error(err);
        this.$toast.error('Could not add ban, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    getDateToday() {
      return moment().format('YYYY-MM-DD');
    },
    startNewSearch() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.getUsers();
      }, 500);
    },
    getUsers() {
      this.loading = true;
      VisitorUsersService.getUsersWithContactInPrison(this.filters).then(res => {
        this.users = res.data.data.map(user => ({ ...user, text: `${user.firstname} ${user.lastname} (${user.email})`, value: user }));
      }).catch(err => {
        console.error(err);
        this.$toast.error('Could not get users, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
      })
    },
    formatDateToDDMMYYYY() {
      return moment().format('DD-MM-YYYY');
    },
  },
};
</script>
